import React, { useCallback, useEffect } from "react";
import classes from "./blogsFilterPage.module.css";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBlogFilter,
  selectBlogFilter,
  setBlogSearchFilter,
  setBlogStatusFilter,
} from "../../../store/blog/blogFilterSlice";

const blogStatusOptions = [
  { id: "", label: "Select Status" },
  { id: "0", label: "Active" },
  { id: "1", label: "Inactive" },
];

export const BlogsFilterPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { status, search } = useSelector(selectBlogFilter);

  useEffect(() => {
    const searchParam = searchParams.get("search");
    const statusParam = searchParams.get("status");

    if (!searchParam && !statusParam) {
      dispatch(clearBlogFilter());
      return;
    }

    dispatch(setBlogSearchFilter(searchParam ?? null));
    dispatch(setBlogStatusFilter(statusParam ?? null));
  }, [searchParams, dispatch]);

  /* ------------- Update URL + Redux together ------------- */
  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);

      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "search") dispatch(setBlogSearchFilter(value || null));
      if (key === "status") dispatch(setBlogStatusFilter(value || null));
    },
    [dispatch, searchParams, setSearchParams]
  );

  const handleAddBlog = () => {
    navigate("/blogs/add");
  };

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by Order Id or Transaction Id"
          value={search || ""}
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>
      <div className={classes.box__content__dropdown}>
        <CustomDropdown
          id="status"
          label="Select Status"
          options={blogStatusOptions}
          selectedId={status || ""}
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>

      <button className={classes.box__btn} onClick={handleAddBlog}>
        Create Blog
      </button>
    </div>
  );
};
